import { Button, message, Modal } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Table } from "antd";
import "./clientEscalation.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BeforeTableHeader from "../../layouts/beforeTableHeader";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import moment from "moment";
import APICaller from "../../../utils/APICaller";
import secureLocalStorage from "react-secure-storage";
import DuplicateTransactionReasonForm from "../audits/duplicateTransactionReasonForm";
import { JsonToExcel } from "react-json-to-excel";
import HandleSearch from "../../../utils/CommonSearchComponent";
import { exportJson } from "../../../utils/export";
import CustomLoader from "../../common/customLoader";

const ClientEscalation = ({ children = null }) => {
  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const [showLoader, setShowLoader] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [list, setList] = useState([]),
    [listItems, setListItems] = useState([]),
    [transactionDuplicateReason, setTransactionDuplicateReason] = useState(""),
    [allTransactionIdsArr, setAllTransactionIdsArr] = useState([]),
    [visible, setVisible] = useState(false);
  const showModal = () => {
    setGlobalState((prevGlobalState) => {
      return {
        ...prevGlobalState,
        eClientName: null,
        eClientNameVal: null,

        eClientSpocEmail: null,
        eClientSpocEmailVal: null,

        eEmpID: null,
        eEmpIDVal: null,

        eFinancialImpact: null,
        eFinancialImpactVal: null,

        eAgentName: null,
        eAgentNameVal: null,

        eAuditorName: null,
        eAuditorNameVal: null,

        eReportingTlName: null,
        eReportingTlNameVal: null,

        eDepartmentName: null,
        eDepartmentNameVal: null,

        eProcessName: null,
        eProcessNameVal: null,

        eErrorRaiseDate: null,
        eErrorRaiseDateVal: null,

        eTransactionId: null,
        eTransactionIdVal: null,

        eTransactionDate: null,
        eTransactionDateVal: null,

        eErrorDescription: null,
        eErrorDescriptionVal: null,

        eErrorInvestigationRemarks: null,
        eErrorInvestigationRemarksVal: null,

        eErrorImpact: null,
        eErrorImpactVal: null,

        eErrorArea: null,
        eErrorAreaVal: null,

        eErrorType: null,
        eErrorTypeVal: null,

        eErrorStatus: null,
        eErrorStatusVal: null,

        eDayoftheweek: null,
        eDayoftheweekVal: null,

        eAgentTenure: null,
        eAgentTenureVal: null,

        eFeedbackdate: null,
        eFeedbackdateVal: null,

        eRepeatedError: null,
        eRepeatedErrorVal: null,

        eCorrectiveActionTaken: null,
        eCorrectiveActionTakenVal: null,

        rcaLevelOne: null,
        rcaLevelOneVal: null,

        rcaLevelTwo: null,
        rcaLevelTwoVal: null,

        rcaLevelThree: null,
        rcaLevelThreeVal: null,

        rcaLevelFour: null,
        rcaLevelFourVal: null,
      };
    });
    setIsModalOpen(true);
  };

  const getClientEscalationList = async (source = "", pagination = "") => {
    let hasSearchedValue, searchKeyword;
    if (secureLocalStorage.getItem("hasSearchedValue")) {
      hasSearchedValue = "yes";
      searchKeyword = secureLocalStorage.getItem("searchKeyword");
    } else {
      hasSearchedValue = "";
      searchKeyword = "";
    }
    //const searchIn = location.pathname.replace("/", "");
    const searchIn = "client-escalation";
    const callActionFrom = source ? source : "";
    const globalStates = {
      globalState: globalState,
      setGlobalState: setGlobalState,
    };

    const allStates = {
      showLoader: showLoader,
      setShowLoader: setShowLoader,
      pagination: pagination
        ? pagination
        : { current: 1, page: 1, pageSize: 50 },
      setPagination: setPagination,
      list: list,
      setList: setList,

      allTransactionIdsArr: allTransactionIdsArr,
      setAllTransactionIdsArr: setAllTransactionIdsArr,
      listItems: listItems,
      setListItems: setListItems,
    };

    await HandleSearch(
      hasSearchedValue,
      searchIn,
      searchKeyword,
      callActionFrom,
      globalStates,
      allStates
    );
  };

  {
    /*Setting state for showing Duplication Transaction ID popup as well as it value on Audits Detail Section*/
  }
  const onCreate = (values) => {
    values?.transactionDuplicateReason &&
      setTransactionDuplicateReason(values?.transactionDuplicateReason);
    //"Reason for duplicate Transaction ID"
    setGlobalState((prevGlobalState) => ({
      ...prevGlobalState,
      transactionDuplicateReason:
        values?.transactionDuplicateReason &&
        values?.transactionDuplicateReason,
    }));
    setVisible(false);
  };
  {
    /*Create CLient Escalation - Submit click*/
  }

  const handleOk = () => {
    let submitFormModal = "";
    if (isModalVisible === true) {
      submitFormModal = "clickedOK";
    }

    const lIUId = secureLocalStorage.getItem("lIUId");

    if (
      globalState?.eClientName &&
      globalState?.eClientSpocEmail &&
      globalState?.eEmpID &&
      globalState?.eFinancialImpact &&
      (globalState?.eAgentName || globalState?.eAuditorName) &&
      globalState?.eDepartmentName &&
      globalState?.eProcessName &&
      globalState?.eReportingTlName &&
      globalState?.eErrorRaiseDateVal &&
      globalState?.eTransactionId &&
      globalState?.eTransactionDateVal &&
      globalState?.eErrorDescriptionVal &&
      globalState?.eErrorImpactVal &&
      globalState?.eErrorArea &&
      globalState?.eErrorType &&
      globalState?.eErrorStatus &&
      globalState?.eDayoftheweek &&
      globalState?.eAgentTenure &&
      globalState?.eFeedbackdate &&
      globalState?.eRepeatedError &&
      globalState?.eCorrectiveActionTaken &&
      globalState?.rcaLevelOneVal &&
      globalState?.rcaLevelTwoVal &&
      globalState?.rcaLevelThreeVal &&
      globalState?.rcaLevelFourVal
    ) {
      let transactionDate = moment(globalState?.eTransactionDateVal).format(
        "YYYY-MM-DD"
      );

      let eErrorRaiseDate = moment(globalState?.eErrorRaiseDateVal).format(
        "YYYY-MM-DD"
      );
      let createdAt = new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      let createdBy = lIUId;
      let stage = "Completed";
      let status = "ACTIVE";
      if (submitFormModal === "clickedOK") {
        setIsModalOpen(false);
        setIsModalVisible(false);
        setVisible(false);
        const endpoint = `/client-escalation`;
        const method = "POST";
        const payload = {
          client: globalState?.eClientName,
          clientSpocEmail: globalState?.eClientSpocEmail,
          empID: globalState?.eEmpID,
          financialImpact: globalState?.eFinancialImpact,
          agent: globalState?.eAgentName,
          auditor: globalState?.eAuditorName,
          reportingTl: globalState?.eReportingTlName,
          department: globalState?.eDepartmentName,
          process: globalState?.eProcessName,
          transactionId: globalState?.eTransactionId,
          transactionDuplicateReason: transactionDuplicateReason,
          transactionDate: transactionDate,
          errorRaiseDate: eErrorRaiseDate,
          errorDescription: globalState?.eErrorDescription,
          errorInvestigationRemarks: globalState?.eErrorInvestigationRemarks,
          errorImpact: globalState?.eErrorImpact,
          errorArea: globalState?.eErrorArea,
          errorType: globalState?.eErrorType,
          errorStatus: globalState?.eErrorStatus,
          dayoftheweek: globalState?.eDayoftheweek,
          agentTenure: globalState?.eAgentTenure,
          feedbackdate: globalState?.eFeedbackdate,
          repeatedError: globalState?.eRepeatedError,
          correctiveActionTaken: globalState?.eCorrectiveActionTaken,
          rcaLevelOne: globalState?.rcaLevelOneVal,
          rcaLevelTwo: globalState?.rcaLevelTwoVal,
          rcaLevelThree: globalState?.rcaLevelThreeVal,
          rcaLevelFour: globalState?.rcaLevelFourVal,
          stage,
          status,
          createdAt,
          createdBy,
        };

        APICaller(slsRole, slsToken, endpoint, method, payload)
          .then((response) => {
            navigate("/escalations/client-escalation/" + response?._id, {
              state: {
                route: location.pathname,
                client: response?.client?.name,
                clientSpocEmail: response?.clientSpocEmail,
                empID: response?.empID,
                financialImpact: response?.eFinancialImpact,
                agent: response?.agent?.name,
                auditor: response?.auditor?.name,
                department: response?.department?.name,
                process: response?.process?.name,
                reportingTl: response?.reportingTl?.name,
                transactionDate: response?.transactionDate,
                transactionId: response?.eTransactionId,
                errorRaiseDate: response?.eErrorRaiseDate,
                errorDescription: response?.eErrorDescription,
                errorInvestigationRemarks: response?.eErrorInvestigationRemarks,
                errorImpact: response?.eErrorImpact,
                errorArea: response?.eErrorArea,
                errorType: response?.eErrorType,
                errorStatus: response?.eErrorStatus,
                dayoftheweek: response?.eDayoftheweek,
                agentTenure: response?.eAgentTenure,
                feedbackdate: response?.eFeedbackdate,
                repeatedError: response?.eRepeatedError,
                correctiveActionTaken: response?.eCorrectiveActionTaken,
                rcaLevelOne: response?.rcaLevelOne,
                rcaLevelTwo: response?.rcaLevelTwo,
                rcaLevelThree: response?.rcaLevelThree,
                rcaLevelFour: response?.rcaLevelFour,
              },
            });
          })
          .catch((error) => {});
      } else {
        setIsModalOpen(true);
        setIsModalVisible(true);
      }
    } else if (
      allTransactionIdsArr.includes(globalState?.eTransactionIdVal) &&
      transactionDuplicateReason === ""
    ) {
      setIsModalOpen(true);
      setVisible(true);
    } else {
      setIsModalOpen(true);

      setGlobalState((prevGlobalState) => ({
        ...prevGlobalState,
        eClientName: globalState?.eClientNameVal
          ? globalState?.eClientNameVal
          : "Client Name is required",
        eClientSpocEmail: globalState?.eClientSpocEmailVal
          ? globalState?.eClientSpocEmailVal
          : "Client SPOC Email is required",
        eEmpID: globalState?.eEmpIDVal
          ? globalState?.eEmpIDVal
          : "Emp ID is required",
        eFinancialImpact: globalState?.eFinancialImpactVal
          ? globalState?.eFinancialImpactVal
          : "Financial Impact is required",
        eAgentName: globalState?.eAgentNameVal
          ? globalState?.eAgentNameVal
          : "Agent Name is required",
        eReportingTlName: globalState?.eReportingTlNameVal
          ? globalState?.eReportingTlNameVal
          : "Reporting TL is required",
        eDepartmentName: globalState?.eDepartmentNameVal
          ? globalState?.eDepartmentNameVal
          : "Department Name is required",
        eProcessName: globalState?.eProcessNameVal
          ? globalState?.eProcessNameVal
          : "Process Name is required",
        eErrorArea: globalState?.eErrorAreaVal
          ? globalState?.eErrorAreaVal
          : "Error Area is required",
        eErrorType: globalState?.eErrorTypeVal
          ? globalState?.eErrorTypeVal
          : "Error Type is required",
        eErrorRaiseDate: globalState?.eErrorRaiseDateVal
          ? globalState?.eErrorRaiseDateVal
          : "Error raise date is required",
        eTransactionId: globalState?.eTransactionIdVal
          ? globalState?.eTransactionIdVal
          : "Transaction ID is required",
        eTransactionDate: globalState?.eTransactionDateVal
          ? globalState?.eTransactionDateVal
          : "Transaction Date is required",
        eErrorDescription: globalState?.eErrorDescriptionVal
          ? globalState?.eErrorDescriptionVal
          : "Error description is required",
        eErrorImpact: globalState?.eErrorImpactVal
          ? globalState?.eErrorImpactVal
          : "Error impact is required",
        eErrorStatus: globalState?.eErrorStatusVal
          ? globalState?.eErrorStatusVal
          : "Error status is required",
        eDayoftheweek: globalState?.eDayoftheweekVal
          ? globalState?.eDayoftheweekVal
          : "Day of the week is required",
        eAgentTenure: globalState?.eAgentTenureVal
          ? globalState?.eAgentTenureVal
          : "Agent tenure is required",
        eFeedbackdate: globalState?.eFeedbackdateVal
          ? globalState?.eFeedbackdateVal
          : "Feedback date is required",
        eRepeatedError: globalState?.eRepeatedErrorVal
          ? globalState?.eRepeatedErrorVal
          : "Repeated error is required",
        eCorrectiveActionTaken: globalState?.eCorrectiveActionTakenVal
          ? globalState?.eCorrectiveActionTakenVal
          : "Corrective action taken is required",
        rcaLevelOne: globalState?.rcaLevelOneVal
          ? globalState?.rcaLevelOneVal
          : "RCA Level One is required",
        rcaLevelTwo: globalState?.rcaLevelTwoVal
          ? globalState?.rcaLevelTwoVal
          : "RCA Level Two is required",
        rcaLevelThree: globalState?.rcaLevelThreeVal
          ? globalState?.rcaLevelThreeVal
          : "RCA Level Three is required",
        rcaLevelFour: globalState?.rcaLevelFourVal
          ? globalState?.rcaLevelFourVal
          : "RCA Level Four is required",
      }));
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [selectionType, setSelectionType] = useState("checkbox");

  const columns = [
    {
      title: () => {
        return <div className="tableTitle"> ID</div>;
      },
      dataIndex: "id",
      render: (text) => (
        <span className="rowstyle">
          <Link
            to={"/escalations/client-escalation/" + text}
            style={{ color: "black" }}
          >
            <span
              className="rowstyle"
              style={{ color: "#1875CB" }}
              onClick={() => {
                secureLocalStorage.setItem(
                  "fromComponent",
                  "client-escalation"
                );
              }}
            >
              {text}
            </span>
          </Link>
        </span>
      ),
    },
    {
      title: () => {
        return <div className="tableTitle">Impact</div>;
      },
      dataIndex: "errorImpact",
      align: "center",
      render: (text) => (
        <span className="rowstyle">
          {" "}
          <img
            src={
              text === "HIGH"
                ? "../high.png"
                : text === "MEDIUM"
                ? "../medium.png"
                : "../low.png"
            }
            style={{ width: "17px" }}
            alt="logo"
          />
          &nbsp;{}
        </span>
      ),
    },

    {
      title: () => {
        return <div className="tableTitle">Transaction ID</div>;
      },
      dataIndex: "transaction",
      render: (text, row) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle">Department</div>;
      },
      dataIndex: "department",
      render: (text) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle">Client</div>;
      },
      dataIndex: "client",
      render: (text) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle">Status</div>;
      },
      dataIndex: "stage",
      render: (text) => (
        <span className="rowstyle">
          {" "}
          <img
            src={
              text === "Audited"
                ? "../audited.PNG"
                : text === "Pending"
                ? "../pending.png"
                : text === "Completed"
                ? "../completed.png"
                : "../disputed.png"
            }
            style={{ width: "17px" }}
            alt="logo"
          />
          &nbsp;{text}
        </span>
      ),
    },

    {
      title: () => {
        return <div className="tableTitle">Raised Date</div>;
      },
      dataIndex: "errorRaiseDate",
      render: (text) => <span className="rowstyle">{text}</span>,
    },

    {
      title: () => {
        return <div className="tableTitle">Reporting TL</div>;
      },
      align: "center",
      dataIndex: "reportingTl",
      render: (text) => {
        return (
          text && (
            <span className="rowstyle">
              <>
                <img
                  className="auditProfileImage"
                  src={process.env.REACT_APP_BACKEND + "/images/dummy.jpg"}
                  alt={text}
                />{" "}
                {text}
              </>
            </span>
          )
        );
      },
    },
    {
      title: () => {
        return <div className="tableTitle">Agent</div>;
      },
      dataIndex: "agent",
      render: (text) => {
        return (
          text && (
            <span className="rowstyle">
              <>
                <img
                  className="auditProfileImage"
                  src={process.env.REACT_APP_BACKEND + "/images/dummy.jpg"}
                  alt={text}
                />{" "}
                {text}
              </>
            </span>
          )
        );
      },
    },
    {
      title: () => {
        return <div className="tableTitle">Auditor</div>;
      },
      dataIndex: "auditor",
      render: (text) => {
        return (
          text && (
            <span className="rowstyle">
              <>
                {text?.name && (
                  <img
                    className="auditProfileImage"
                    src={process.env.REACT_APP_BACKEND + "/images/dummy.jpg"}
                    alt={text}
                  />
                )}{" "}
                {text}
              </>
            </span>
          )
        );
      },
    },
  ];

  {
    /*Export functionality on Client Escalation Listing's table clicking on checkboxes*/
  }
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);

      const exportColumns = [
        { key: "Advisor Emp Code", path: "empID" },
        { key: "Advisor Agent", path: "agent" },
        { key: "Department", path: "department" },
        { key: "Process", path: "process" },
        { key: "Client Name", path: "client" },
        { key: "Client SPOC Email id", path: "clientSpocEmail" },
        {
          key: "Error Raise Date",
          path: "errorRaiseDate",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
        },
        { key: "Reporting TL", path: "reportingTl" },
        { key: "Policy id / Transaction ID", path: "transactionId" },
        {
          key: "Transaction Duplicate Reason",
          path: "transactionDuplicateReason",
        },
        {
          key: "Transaction Date",
          path: "transactionDate",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
        },
        { key: "Error Description", path: "errorDescription" },
        { key: "Error Impact", path: "errorImpact" },
        {
          key: "Error Investigation Remarks",
          path: "errorInvestigationRemarks",
        },
        { key: "Error Status", path: "errorStatus" },
        { key: "Rca Level One", path: "rcaLevelOne" },
        { key: "Rca Level Two", path: "rcaLevelTwo" },
        { key: "Rca Level Three", path: "rcaLevelThree" },
        { key: "Rca Level Four", path: "rcaLevelFour" },

        { key: "Day of the week", path: "dayoftheweek" },
        { key: "Advisor Tenure", path: "agentTenure" },
        {
          key: "Feedback Date",
          path: "feedbackdate",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
        },
        { key: "Repeated Error", path: "repeatedError" },
        { key: "Revenue Impacted", path: "financialImpact" },
        { key: "Error Area", path: "errorArea" },
        { key: "Error Type", path: "errorType" },
        { key: "Stage", path: "stage" },
        {
          key: "Created At",
          path: "createdAt",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
        },
        {
          key: "Updated At",
          path: "updatedAt",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
        },
      ];

      exportJson(
        selectedRows,
        globalState?.clientEscalationLists,
        "ClientEscalationReport",
        exportColumns,
        setGlobalState,
        globalState
      );
    },
  };
  const [pagination, setPagination] = useState({ current: 1, pageSize: 50 });

  {
    /*Client Escalation Complete and Delete action*/
  }
  const handleClientEscalationAction = (params) => {
    switch (params) {
      case "complete":
        const endpoint = `/client-escalation/updateMul`;
        const method = "POST";
        const payload = {
          role: secureLocalStorage.getItem("role"),
          ids: globalState.selectedRowKeysChildInfo,
        };

        APICaller(slsRole, slsToken, endpoint, method, payload)
          .then((response) => {
            getClientEscalationList();
            setSelectedRowKeys([]);
          })
          .catch((error) => {});
        break;
      case "delete":
        let submitDeleteAuditFormModal = "";
        if (isDeleteModalVisible === true) {
          submitDeleteAuditFormModal = "clickedDeleteAuditOK";
        }
        if (submitDeleteAuditFormModal === "clickedDeleteAuditOK") {
          setShowLoader(true);
          const endpoint = `/client-escalation/deleteMul`;
          const method = "POST";
          const payload = {
            role: secureLocalStorage.getItem("role"),
            ids: globalState.selectedRowKeysChildInfo,
          };

          APICaller(slsRole, slsToken, endpoint, method, payload)
            .then((response) => {
              setIsDeleteModalVisible(false);
              getClientEscalationList();
              setSelectedRowKeys([]);
            })
            .catch((error) => {});
        } else {
          setIsDeleteModalVisible(true);
        }
        break;
    }
  };
  useEffect(() => {
    getClientEscalationList();
  }, []);

  return (
    <>
      <div className="all-content">
        <div className="d-flex">
          <BeforeTableHeader list={listItems} showListingCount="yes" href="" />

          <div className="right-buttons">
            {(secureLocalStorage.getItem("role") === "admin" ||
              secureLocalStorage.getItem("role") === "qc") && (
              <>
                {globalState.selectedRowKeysChildInfo &&
                  globalState.selectedRowKeysChildInfo.length > 0 && (
                    <JsonToExcel
                      title="Download as Excel"
                      data={globalState.exportClientEscalationReportJson}
                      fileName="clientEscalationReport"
                      btnClassName="table-buttons"
                    />
                  )}
                {secureLocalStorage.getItem("role") === "admin" &&
                  globalState.selectedRowKeysChildInfo &&
                  globalState.selectedRowKeysChildInfo.length > 0 && (
                    <span
                      className="escalationDelete auditDelete table-buttons"
                      onClick={() => {
                        handleClientEscalationAction("delete");
                      }}
                    >
                      Delete
                    </span>
                  )}
                <span className="performClientEscalation" onClick={showModal}>
                  <Link to="" style={{ color: "black" }}>
                    {" "}
                    + New Client Escalation
                  </Link>
                </span>
                <Modal
                  className="all-modal"
                  onCancel={handleCancel}
                  onOk={handleOk}
                  title={
                    <div className="headermodaltitle">
                      Create New Client Escalation
                    </div>
                  }
                  open={isModalOpen}
                  bodyStyle={{ height: "70vh", overflowY: "scroll" }}
                  footer={[
                    <Button
                      key="back"
                      className="submit-btn border-0 rounded"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>,
                    <Button
                      key="submit"
                      className="submit-btn border-0 rounded"
                      onClick={handleOk}
                    >
                      Create Client Escalation
                    </Button>,
                  ]}
                  width={"50vw"}
                >
                  {children}
                </Modal>
              </>
            )}
          </div>
        </div>

        <div className="all-table-holder">
          <CustomLoader showLoader={showLoader} />

          <Table
            rowSelection={{ type: selectionType, ...rowSelection }}
            columns={columns}
            dataSource={globalState.clientEslist}
            pagination={globalState?.pagination}
            onChange={(e) => {
              getClientEscalationList("pagination", e);
            }}
          />
        </div>
      </div>
      <DuplicateTransactionReasonForm
        open={visible}
        setVisible={setVisible}
        onCreate={onCreate}
      />
      <Modal
        title=""
        open={isModalVisible}
        onOk={handleOk}
        onCancel={() => {
          setIsModalVisible(false);
          setIsModalOpen(true);
        }}
        okText="OK"
        cancelText="Cancel"
        className="clientEscalationModal"
      >
        Please review your selected or entered information carefully before
        submitting the form, as changes may not be possible once it's submitted.
      </Modal>

      <Modal
        title=""
        open={isDeleteModalVisible}
        onOk={() => {
          handleClientEscalationAction("delete");
        }}
        onCancel={() => {
          setIsDeleteModalVisible(false);
        }}
        okText="Yes"
        cancelText="No"
        className="clientEscalationModal"
      >
        Are you sure you want to delete this client escalation?
      </Modal>
    </>
  );
};
export default ClientEscalation;
